export default __webpack_public_path__ + "../staticImages/sprite-apple-pay-2x.png";